<template>
  <div
    class="rounded w-2/5 px-4 py-3 flex flex-col items-center justify-between bg-truegray-100 text-truegray-500 cursor-pointer z-20 relative"
    @click="toggleShowingOptions"
  >
    <div class="flex justify-between w-full">
      <div class="text-xs text-truegray-500">
        <span>Order by: </span>
        <span v-if="selectedOptionText" class="lowercase">
          {{ selectedOptionText }}
        </span>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="w-4 h-4"
      >
        <path
          fill-rule="evenodd"
          d="M2.24 6.8a.75.75 0 0 0 1.06-.04l1.95-2.1v8.59a.75.75 0 0 0 1.5 0V4.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L2.2 5.74a.75.75 0 0 0 .04 1.06Zm8 6.4a.75.75 0 0 0-.04 1.06l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75a.75.75 0 0 0-1.5 0v8.59l-1.95-2.1a.75.75 0 0 0-1.06-.04Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <div v-if="showingOptions" class="absolute top-full w-full bg-truegray-100">
      <ul
        class="no-scrollbar transform ease-in-out duration-300 max-h-56 shadow-md w-full absolute left-0 z-70 bg-white text-base sm:text-sm overflow-auto focus:outline-none rounded-b-xl"
      >
        <li
          v-for="(option, i) in options"
          :id="option.value"
          :key="i"
          :class="[
            'w-full cursor-pointer border-b last:border-transparent relative flex items-center h-12 hover:bg-truegray-100',
            { 'bg-truegray-100': isSelected(option.value) },
          ]"
          @click="selectOption(option)"
        >
          <div class="flex justify-between items-center w-full space-x-2 px-6">
            <div
              class="flex gap-2 block truncate"
              :title="`${option.text} ${option.subtext}`"
            >
              <span class="text-truegray-500 text-left">
                {{ option.text }}
              </span>
              <span class="text-truegray-400 text-left">
                {{ option.subtext }}
              </span>
            </div>

            <span v-html="option.icon" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default defineComponent({
  name: 'InputDropdownListSelector',

  props: {
    options: {
      type: Array,
      required: true,
    },

    selectedOption: {
      type: Object,
      required: true,
    },
  },

  emits: ['on-submit'],

  setup(props, { emit }) {
    const showingOptions = ref(false)

    const selectedOption = computed(() => props.selectedOption)
    const selectedOptionText = computed(() => {
      return `${selectedOption.value?.selectedText}`
    })

    const isSelected = (value) => {
      return selectedOption.value?.value === value
    }

    const selectOption = (opt) => {
      emit('on-submit', opt)
    }

    const toggleShowingOptions = () => {
      showingOptions.value = !showingOptions.value
    }

    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      showingOptions,
      selectedOptionText,
      isSelected,
      selectOption,
      toggleShowingOptions,
    }
  },
})
</script>
